import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana81Div4M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  <rect width="1221" height="921" fill="url(#pattern0_1455_8409)"/>
  <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}  
      d="M596.844 738.227L607.895 782.43L539.38 800.111L528.329 758.118L596.844 738.227Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
  <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}  
      d="M583.58 694.027L596.841 738.23L528.326 758.122L517.275 713.919L583.58 694.027Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
  <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}  
      d="M572.54 652.031L583.591 694.024L517.286 713.916L506.235 669.713L572.54 652.031Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
  <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}  
      d="M559.272 607.832L572.533 652.035L506.229 669.716L492.968 625.513L559.272 607.832Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
  <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}  
      d="M548.223 563.623L559.273 607.826L492.969 625.507L481.918 583.514L548.223 563.623Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
  <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}  
      d="M537.166 519.424L548.217 563.627L481.912 583.518L468.651 539.315L537.166 519.424Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
  <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}  
      d="M526.122 477.428L537.173 519.421L468.658 539.312L457.607 497.319L526.122 477.428Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
  <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}  
      d="M512.86 433.229L526.121 477.432L457.606 497.323L444.345 453.12L512.86 433.229Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
  <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}  
      d="M501.805 389.025L512.856 433.229L444.341 453.12L433.29 408.917L501.805 389.025Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
  <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}  
      d="M488.552 347.031L501.813 389.024L433.298 408.916L422.247 364.713L488.552 347.031Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
  <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}  
      d="M477.496 302.828L488.547 347.031L422.242 364.713L411.191 322.72L477.496 302.828Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
  <defs>
  <pattern id="pattern0_1455_8409" patternContentUnits="objectBoundingBox" width="1" height="1">
  <use href="#image0_1455_8409" transform="matrix(0.00156612 0 0 0.00207625 -4.18492 -2.49739)"/>
  </pattern>
  <image id="image0_1455_8409" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};